import { MenuItem, Select } from '@mui/material';
import ArrowDown from 'assets/icons/arrow-down.svg';
import { arrayOf, string } from 'prop-types';
import React from 'react';
import { useLocation } from 'react-router';
import shortCompany from 'shapes/shortCompany';
import { setActiveCompanyId } from 'utils/activeCompany';
import redirect from 'utils/redirect';
import connector from './connector';

const selectSx = theme => ({
  marginTop: '2px',
  border: '1px solid transparent',
  borderRadius: '20px',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
  '& .MuiSelect-select': {
    paddingLeft: '10px',
    paddingRight: '23px',
    borderRadius: '20px',
    color: theme.palette.secondary.main,
  },
  '& .MuiSelect-icon': {
    color: theme.palette.secondary.extraLight,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 0,
    display: 'none',
  },
});

const arrowSx = {
  display: 'block',
  width: '12px',
  height: '12px',
  top: 'calc(50% - 6px)',
  right: '6px',
  position: 'absolute',
  pointerEvents: 'none',
};

const ArrowDownComponent = ({ className }) => <ArrowDown className={className} style={arrowSx} />;

const CompaniesDropdown = ({ companies, companyId }) => {
  const location = useLocation();
  const handleChange = e => {
    const { _id, subDomain } = companies.find(c => c._id === e.target.value);

    // Cache the target id for apex/preview hosts; on real subdomains x-company is derived from the
    // URL after the hop, so no pre-navigation flush/seed dance is needed.
    setActiveCompanyId(_id);
    const path = location.pathname.split('/').slice(0, 3).join('/');
    redirect(path, subDomain);
  };

  if (companies?.length === 1) {
    return null;
  }

  return (
    <Select
      variant="standard"
      disableUnderline
      value={companyId}
      sx={selectSx}
      onChange={handleChange}
      IconComponent={ArrowDownComponent}
    >
      {companies.map(c => (
        <MenuItem key={c._id} value={c._id}>
          {c.name}
        </MenuItem>
      ))}
    </Select>
  );
};

CompaniesDropdown.propTypes = {
  companies: arrayOf(shortCompany).isRequired,
  companyId: string.isRequired,
};

export default connector(CompaniesDropdown);
